/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { veTokenAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type WithdrawTokensFromExpiredVeProps = {
  account: Address
  chainId: number
  config: Config
  vestedAddress: Address
  tokenId: number
}

export const withdrawTokensFromExpiredVe = async ({
  account,
  chainId,
  config,
  vestedAddress,
  tokenId,
}: WithdrawTokensFromExpiredVeProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: veTokenAbi as Abi,
        account,
        address: vestedAddress,
        args: [tokenId],
        chainId,
        functionName: "withdraw",
      },
    })
    return result
  } catch (error: any) {
    console.error("withdrawTokensFromExpiredVe", error)
    return { success: false, error: error?.message, code: error?.code }
  }
}

/*
const withdraw = async ({ web3, tokenId, account, gasPrice, vestedAddress }) => {
  const options = { from: account }
  if (gasPrice) {
    options["gasPrice"] = gasPrice
  }
  try {
    const veTokenContract = new web3.eth.Contract(veTokenAbi, vestedAddress)
    const tx = await veTokenContract.methods.withdraw(tokenId).send(options)
    return { tx, success: true }
  } catch (error: any) {
    console.error("withdraw", error)
    // @ts-ignore
    return { tx: null, success: false, error: error.message, code: error.code }
  }
}
*/
